import { Component, OnInit } from '@angular/core';
import { ForecastYearEditable } from '../../services/forecast-year-editable.service';

@Component({
	selector: 'app-comparative-year',
	templateUrl: './comparative-year.component.html',
	styleUrls: ['./comparative-year.component.scss'],
})
export class ComparativeYearComponent implements OnInit {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	// Line Chart
	lineAreaChart!: any;
	localservice: any;
	months: any;
	monthsReal: any;
	labels: string[];
	options: any;
	datasets: any;
	lastYear: any;

	constructor(private forecastYearEditable: ForecastYearEditable) {
		this.months = [];
		this.monthsReal = [];
		this.lastYear = [];
		this.labels = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		this.options = {
			defaultFontColor: '#8791af',
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				xAxes: [{ gridLines: { color: 'rgba(166, 176, 207, 0.1)' } }],
				yAxes: [
					{
						ticks: { max: 100, min: 20, stepSize: 12 },
						gridLines: { color: 'rgba(166, 176, 207, 0.1)' },
					},
				],
			},
		};
		this.datasets = [
			{
				label: 'Real Leads',
				fill: true,
				lineTension: 0.5,
				backgroundColor: 'rgba( 10, 179, 156, 0.2)',
				borderColor: '#0d68c3',
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				pointBorderColor: '#0d68c3',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 1,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#0d68c3',
				pointHoverBorderColor: '#fff',
				pointHoverBorderWidth: 2,
				pointRadius: 1,
				pointHitRadius: 12,
				data: [],
			},
			{
				label: 'Forcasted Leads',
				fill: true,
				lineTension: 0.5,
				backgroundColor: 'rgba( 10, 179, 156, 0.2)',
				borderColor: '#0ab39c',
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				pointBorderColor: '#0ab39c',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 1,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#0ab39c',
				pointHoverBorderColor: '#eef0f2',
				pointHoverBorderWidth: 2,
				pointRadius: 1,
				pointHitRadius: 12,
				data: [],
			},
			{
				label: 'Forcasted Leads',
				fill: true,
				lineTension: 0.5,
				backgroundColor: 'rgba( 252, 186, 3, 0.2)',
				borderColor: '#fcba03',
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				pointBorderColor: '#fcba03',
				pointBackgroundColor: '#fff',
				pointBorderWidth: 1,
				pointHoverRadius: 5,
				pointHoverBackgroundColor: '#fcba03',
				pointHoverBorderColor: '#eef0f2',
				pointHoverBorderWidth: 2,
				pointRadius: 1,
				pointHitRadius: 12,
				data: [],
			},
		];
	}

	ngOnInit(): void {
		/**
		 * BreadCrumb
		 */
		this.breadCrumbItems = [
			{ label: 'Charts' },
			{ label: 'Chartjs', active: true },
		];

		//this.forecastYearEditable.getMonths();

		this.forecastYearEditable.getMonthsO().subscribe((data) => {
			this.months = [
				data.body[0].jan,
				data.body[0].feb,
				data.body[0].mar,
				data.body[0].apr,
				data.body[0].may,
				data.body[0].jun,
				data.body[0].jul,
				data.body[0].ago,
				data.body[0].sep,
				data.body[0].oct,
				data.body[0].nov,
				data.body[0].dic,
			];
		});

		this.forecastYearEditable.getLastYearMonthsO().subscribe((data) => {
			this.lastYear = [
				data.body[0].jan,
				data.body[0].feb,
				data.body[0].mar,
				data.body[0].apr,
				data.body[0].may,
				data.body[0].jun,
				data.body[0].jul,
				data.body[0].ago,
				data.body[0].sep,
				data.body[0].oct,
				data.body[0].nov,
				data.body[0].dic,
			];
		});

		setTimeout(() => {
			this.forecastYearEditable.getRealMonthsO().subscribe((data) => {
				this.monthsReal = [
					data.body[0].jan,
					data.body[0].feb,
					data.body[0].mar,
					data.body[0].apr,
					data.body[0].may,
					data.body[0].jun,
					data.body[0].jul,
					data.body[0].ago,
					data.body[0].sep,
					data.body[0].oct,
					data.body[0].nov,
					data.body[0].dic,
				];
				this.lineAreaChart = {
					labels: this.labels,
					datasets: [
						{
							label: 'Real Leads',
							fill: true,
							lineTension: 0.5,
							backgroundColor: 'rgba( 10, 179, 156, 0.2)',
							borderColor: '#0d68c3',
							borderCapStyle: 'butt',
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: 'miter',
							pointBorderColor: '#0d68c3',
							pointBackgroundColor: '#fff',
							pointBorderWidth: 1,
							pointHoverRadius: 5,
							pointHoverBackgroundColor: '#0d68c3',
							pointHoverBorderColor: '#fff',
							pointHoverBorderWidth: 2,
							pointRadius: 1,
							pointHitRadius: 12,
							data: this.monthsReal,
						},
						{
							label: 'Forcasted Leads',
							fill: true,
							lineTension: 0.5,
							backgroundColor: 'rgba( 10, 179, 156, 0.2)',
							borderColor: '#0ab39c',
							borderCapStyle: 'butt',
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: 'miter',
							pointBorderColor: '#0ab39c',
							pointBackgroundColor: '#fff',
							pointBorderWidth: 1,
							pointHoverRadius: 5,
							pointHoverBackgroundColor: '#0ab39c',
							pointHoverBorderColor: '#eef0f2',
							pointHoverBorderWidth: 2,
							pointRadius: 1,
							pointHitRadius: 12,
							data: this.months,
						},
						{
							label: 'Last Year Leads',
							fill: true,
							lineTension: 0.5,
							backgroundColor: 'rgba( 252, 186, 3, 0.2)',
							borderColor: '#fcba03',
							borderCapStyle: 'butt',
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: 'miter',
							pointBorderColor: '#fcba03',
							pointBackgroundColor: '#fff',
							pointBorderWidth: 1,
							pointHoverRadius: 5,
							pointHoverBackgroundColor: '#fcba03',
							pointHoverBorderColor: '#eef0f2',
							pointHoverBorderWidth: 2,
							pointRadius: 1,
							pointHitRadius: 12,
							data: this.lastYear,
						},
					],
					options: this.options,
				};
			});
		}, 2000);

		this._lineAreaChart(
			'["--vz-primary-rgb, 0.2", "--vz-primary", "--vz-success-rgb, 0.2", "--vz-success"]',
		);
	}

	// Chart Colors Set
	private getChartColorsArray(colors: any) {
		colors = JSON.parse(colors);
		return colors.map(function (value: any) {
			var newValue = value.replace(' ', '');
			if (newValue.indexOf(',') === -1) {
				var color = getComputedStyle(
					document.documentElement,
				).getPropertyValue(newValue);
				if (color) {
					color = color.replace(' ', '');
					return color;
				} else return newValue;
			} else {
				var val = value.split(',');
				if (val.length == 2) {
					var rgbaColor = getComputedStyle(
						document.documentElement,
					).getPropertyValue(val[0]);
					rgbaColor = 'rgba(' + rgbaColor + ',' + val[1] + ')';
					return rgbaColor;
				} else {
					return newValue;
				}
			}
		});
	}

	/**
	 * Line Area Chart
	 */

	private _lineAreaChart(colors: any) {
		colors = this.getChartColorsArray(colors);
		this.lineAreaChart = {
			labels: this.labels,
			datasets: this.datasets,
			options: this.options,
		};
	}
}
